export interface ComponentsSizesType {
  wrapperWidth: number;
  wrapperHeight: number;
  newContentWidth: number;
  newContentHeight: number;
}

export enum BoundsMode { // eslint-disable-line
  NORMAL,
  CENTER_ZOOMED_OUT,
  CENTER_BOUND_EDGES
}

